<template>
  <div id="page-forms">
    <v-container fluid class="hide-on-print">
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">Traveller Details</h3>
        <div class="text-xs-right">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn dark fab x-small class="mr-2" color="blue darken-3" @click="attachDocument" v-on="on"
                     v-if="$oauth.checkIfHasPermission(['attach-file'])">
                <v-icon dark>mdi-file-cad</v-icon>
              </v-btn>
            </template>
            <span>Attach File</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn dark fab x-small class="mr-2" color="blue darken-3" @click="showSpecialPaymentDialog" v-on="on"
                     v-if="$oauth.checkIfHasPermission(['add special-case-payment'])">
                <v-icon dark>mdi mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Add Special Case Payment</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn dark fab x-small class="mr-2" color="red darken-3" @click="showEntryRefuseDialog" v-on="on"
                     v-if="$oauth.checkIfHasPermission(['add entry-refuse'])">
                <v-icon dark>mdi-stop-circle-outline</v-icon>
              </v-btn>
            </template>
            <span>Entry Refuse Traveller</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn dark fab x-small color="blue darken-3" @click="downloadAsPdf" v-on="on">
                <v-icon dark>mdi mdi-file-pdf</v-icon>
              </v-btn>
            </template>
            <span>Download As PDF</span>
          </v-tooltip>
        </div>
      </v-flex>
      <v-card>
        <v-tabs
            background-color="primary"
            dark
            fixed-tabs height="40" v-model="detailTab">
          <v-tabs-slider color="yellow"/>
          <v-tab href="#profile">
            <v-icon class="mr-2" size="15">mdi-account</v-icon>
            Personal Info
          </v-tab>
          <v-tab href="#visa" small v-if="showVisaDetails && traveller &&  traveller.visa_visits">
            <v-icon class="mr-2" size="15">mdi-equal-box</v-icon>
            Visa Details ({{ traveller.visa_visits.length }})
          </v-tab>
          <v-tab href="#details" small v-if="showVisaDetails">
            <v-icon class="mr-2" size="15">mdi-equal-box</v-icon>
            Stay Details
          </v-tab>
          <v-tab href="#track" small>
            <v-icon class="mr-2" size="15">history</v-icon>
            Activity
          </v-tab>
          <v-tab href="#scan_track" small>
            <v-icon class="mr-2" size="15">mdi-qrcode</v-icon>
            Scan Activity
          </v-tab>
          <v-tab href="#profile_photos"
                 v-if="$oauth.checkIfHasPermission(['read profile-photos']) && Object.keys(profile_images).length > 0"
                 small>
            <v-icon class="mr-2" size="15">camera</v-icon>
            Profile Images
          </v-tab>
          <v-tab href="#visa_request" small
                 v-if="(traveller.visa_requests && traveller.visa_requests.length > 0)
                 || (traveller.not_approved_visa_requests && traveller.not_approved_visa_requests.length > 0)">
            <v-icon class="mr-2" size="15">mdi-equal-box</v-icon>
            Visa Requests
          </v-tab>
          <v-tab href="#similar_travellers" small>
            <v-icon class="mr-2" size="15">mdi-account</v-icon>
            Similar Travellers
          </v-tab>

          <v-tab-item value="profile">
            <v-flex class="mx-2" v-if=" traveller.blacklists && traveller.blacklists.length>0" xs12>
              <v-alert outlined type="error">Similar record matching to this person information is found in
                blacklist.
                <v-spacer/>
              </v-alert>
            </v-flex>

            <black-list-detail :black_lists="traveller.blacklists" :traveller_id="traveller.id"
                               @unmarked="unmarked"/>
            <v-layout class="mx-2 pb-4 pt-2" row v-if="!loading" wrap>
              <confirmation-header-text class="ml-0"
                                        icon="mdi-account"
                                        text="Personal Details"/>

              <v-flex class="pl-5 pt-2" sm3 xs6>
                <file-display :avatar="true"
                              :src="traveller.image?traveller.image:'https://i.ibb.co/5TydT4f/logo-min.png'"/>
              </v-flex>

              <v-flex sm3 xs6>
                <list-item-detail :sub_title="traveller.full_name" title="Name"/>
              </v-flex>

              <v-flex sm3 xs6>
                <list-item-detail :sub_title="traveller.contact_number"
                                  title="Contact Number"/>
              </v-flex>

              <v-flex sm3 xs6>
                <list-item-detail :sub_title="traveller.email" title="Email"/>
              </v-flex>
              <v-flex class="pl-1" sm3 xs6>
                <list-item-detail :sub_title="traveller.contact_number_in_nepal"
                                  title="Contact number in Nepal"/>
              </v-flex>

              <v-flex sm3 xs6>
                <list-item-detail :sub_title="traveller.occupation" title="Occupation"/>
              </v-flex>
              <v-flex sm3 xs6>
                <list-item-detail :sub_title="traveller.gender" title="Gender"
                />
              </v-flex>
              <v-flex sm3 xs6>
                <list-item-detail :sub_title="traveller.dob" title="Date of birth"/>
              </v-flex>

              <v-flex sm2 v-if="traveller.country" xs6 class="pl-1">
                <list-item-detail :show-tooltip="true"
                                  :sub_title="traveller.country.country_name" title="Country"/>
              </v-flex>
<!--              <v-flex sm1>-->
<!--                <v-tooltip top>-->
<!--                  <template v-slot:activator="{ on }">-->
<!--                    <v-btn-->
<!--                        @click="editTraveller()"-->
<!--                        class="mr-2"-->
<!--                        color="#FF8316"-->
<!--                        dark-->
<!--                        dense-->
<!--                        fab-->
<!--                        v-on="on"-->
<!--                        x-small>-->
<!--                      <v-icon small>edit</v-icon>-->
<!--                    </v-btn>-->
<!--                  </template>-->
<!--                  <span>Update Traveller Information</span>-->
<!--                </v-tooltip>-->
<!--              </v-flex>-->

              <v-flex xs12>
                <v-divider class="my-3"/>
              </v-flex>

              <v-flex xs12>
                <confirmation-header-text class="ml-0" icon="mdi-file-document"
                                          text="Documents"/>
                <v-layout class="mx-0" row v-for="(document,index) in traveller.documents" :key="index" wrap>
                  <v-flex class="pl-1" xs2>
                    <list-item-detail :sub_title="document.document_type"
                                      title="Document Type"/>
                  </v-flex>
                  <v-flex xs2>
                    <list-item-detail :sub_title="document.document_number"
                                      title="Document Number"/>
                  </v-flex>
                  <v-flex xs2>
                    <list-item-detail :sub_title="document.validity"
                                      title="Document validity"/>
                  </v-flex>
                  <v-flex sm3>
                    <list-item-detail
                        :sub_title="(document.document_holding_country?document.document_holding_country.country_name:'N/A')"
                        title="Document Holding Country"
                    />
                  </v-flex>
                  <v-flex class="d-flex justify-center align-center" :class="document.id?'xs2':'xs2'">
                    <file-display :src="document.document"/>
                  </v-flex>

                  <v-flex xs1 v-if="$oauth.checkIfHasPermission(['mark-document-separate-traveller']) && traveller.documents && traveller.documents.length > 1">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                            @click="separateTraveller(document)"
                            class="ml-1 mt-5"
                            color="blue darken-3"
                            dark
                            dense
                            fab
                            v-on="on"
                            x-small
                        >
                          <v-icon small>check</v-icon>
                        </v-btn>
                      </template>
                      <span>Mark this document as separate traveller</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex xs1 v-if="document.id">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                            @click="editDocument(document)"
                            class="ml-1"
                            color="#FF8316"
                            dark
                            dense
                            fab
                            v-on="on"
                            x-small
                        >
                          <v-icon small>edit</v-icon>
                        </v-btn>
                      </template>
                      <span>Edit Document Type</span>
                    </v-tooltip>
                  </v-flex>

                </v-layout>
              </v-flex>

              <v-flex v-if="$oauth.checkIfHasPermission(['read biometric'])" xs12>
                <v-divider class="my-3"/>
              </v-flex>
              <confirmation-header-text class="ml-0" icon="mdi-fingerprint"
                                        text="Fingerprint"
                                        v-if="$oauth.checkIfHasPermission(['read biometric'])"
              />
              <finger-print
                  :fingerprints_1="traveller.fingerprints.fingerprint_1"
                  :fingerprints_2="traveller.fingerprints.fingerprint_2"
                  v-if="$oauth.checkIfHasPermission(['read biometric']) && traveller.fingerprints"
              />
              <v-flex v-if="$oauth.checkIfHasPermission(['read biometric'])" xs12>
                <v-divider class="my-3"/>
              </v-flex>
              <confirmation-header-text class="ml-0" icon="mdi-eye"
                                        text="Retina scan"
                                        v-if="$oauth.checkIfHasPermission(['read biometric']) "
              />
              <retina-scan
                  :left_retinas="traveller.retinas.left_retina"
                  :right_retinas="traveller.retinas.right_retina"
                  v-if="$oauth.checkIfHasPermission(['read biometric']) && traveller.retinas"
              />
            </v-layout>
          </v-tab-item>
          <v-tab-item v-if="showVisaDetails" value="visa">
            <v-layout class="ml-3 py-1" row v-for="(visa,index) in traveller.visa_visits" :key="index" wrap>
              <v-flex xs2>
                <v-list class="pa-0" two-line>
                  <v-list-item class="pa-0">
                    <v-list-item-content class="py-0">
                      <v-list-item-subtitle style="font-size: 12px;user-select: text;">Visa Type</v-list-item-subtitle>
                      <v-list-item-title style="font-size: 17px; user-select: text;">{{ index + 1 }} {{
                          visa.visa_type
                        }}
                      </v-list-item-title>
                      <span
                          style="font-size: 12px; user-select: text;">({{
                          visa.visa_condition ? visa.visa_condition.name : 'n/a'
                        }})</span>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>

              </v-flex>
              <v-flex xs1>
                <list-item-detail :sub_title="visa.visa_number" title="Visa Number"/>
              </v-flex>
              <v-flex xs1>

                <list-item-detail :sub_title="visa.sticker_number!= 'null'? visa.sticker_number:''"
                                  title="Visa Sticker No."/>
              </v-flex>
              <v-flex xs1>
                <v-list class="pa-0" two-line>
                  <v-list-item class="pa-0">
                    <v-list-item-content class="py-0">
                      <v-list-item-subtitle style="font-size: 12px;user-select: text;">Document No.
                      </v-list-item-subtitle>
                      <v-list-item-title style="font-size: 17px; user-select: text;">
                        {{ visa && visa.document ? visa.document.document_number : 'N/A' }}
                      </v-list-item-title>
                      <span style="font-size: 12px; user-select: text;">({{ visa && visa.document && visa.document.document_type  ? visa.document.document_type.name : 'N/A' }})</span>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-flex>
              <v-flex xs1>
                <list-item-detail :sub_title="visa.submission_no"
                                  title="Submission Id"/>
              </v-flex>
              <v-flex xs1>
                <list-item-detail :sub_title="visa.status"
                                  title="Status"/>
              </v-flex>
              <v-flex xs2>
                <list-item-detail
                    :sub_title="visa.approved_date"
                    title="Visa Approved Date"/>
              </v-flex>
              <v-flex xs2>
                <list-item-detail
                    :sub_title="(visa.start_date && visa.expiry_date ?visa.start_date +' to '+ visa.expiry_date:'-')"
                    title="Visa Duration"/>
              </v-flex>
              <v-flex class="pt-4" xs1>
                <v-btn @click="viewVisa(visa.submission_no)" color="primary" fab x-small>
                  <v-icon>
                    remove_red_eye
                  </v-icon>
                </v-btn>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                        @click="editVisa(visa)"
                        class="ml-1"
                        color="#FF8316"
                        dark
                        dense
                        fab
                        v-if="$oauth.checkIfHasPermission(['update visa-record']) && (index === 0 || visa.submission_no.substr(0,1).toLowerCase() === 'p'  || visa.approved_date === null)"
                        v-on="on"
                        x-small
                    >
                      <v-icon small>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit Expiry Date</span>
                </v-tooltip>
              </v-flex>
              <v-flex v-if="traveller.visa_requests && (index <traveller.visa_visits.length-1)" xs12>
                <v-divider/>
              </v-flex>
            </v-layout>
          </v-tab-item>
          <v-tab-item value="details">
            <div>
              <TravellerPreviousStayLog :traveller-id="traveller.id" />
<!--              <year-log :traveller-id="traveller.id"/>-->
            </div>
          </v-tab-item>
          <v-tab-item value="track">
            <div>
              <visa-history :history="history" :show_load_more="true" :editable="false"/>
            </div>
          </v-tab-item>
          <v-tab-item value="scan_track">
            <div>
              <traveller-scan-history :history="scan_histories" :show_load_more="true" :editable="false"/>
            </div>
          </v-tab-item>

          <v-tab-item value="profile_photos">
            <v-layout class="mx-2 pb-4 pt-2" row v-if="!loading" wrap>
              <v-flex xs12 v-for="(image_key,index) in Object.keys(profile_images)" :key="index">
                <confirmation-header-text class="ml-0" icon="mdi-image-multiple"
                                          :text="image_key"/>
                <v-layout row>
                  <v-flex class="d-flex justify-center align-center xs4" v-for="(image,index) in profile_images[image_key]" :key="index">
                    <file-display :src="image"/>
                  </v-flex>
                </v-layout>
                <v-flex xs12>
                  <v-divider class="my-3"/>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-tab-item>

          <v-tab-item value="visa_request">
            <div v-if="traveller.visa_requests && traveller.visa_requests.length > 0">
              <v-layout class="ml-3 py-1" row v-for="(visa,index) in traveller.visa_requests" :key="index" wrap>
                <v-flex xs2>
                  <v-list class="pa-0" two-line>
                    <v-list-item class="pa-0">
                      <v-list-item-content class="py-0">
                        <v-list-item-subtitle style="font-size: 12px;user-select: text;">Visa Type
                        </v-list-item-subtitle>
                        <v-list-item-title style="font-size: 17px; user-select: text;">{{ visa.type }}
                        </v-list-item-title>
                        <span style="font-size: 12px; user-select: text;">({{ visa.name }})</span>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-flex>


                <v-flex xs1>
                  <list-item-detail :sub_title="visa.submission_no"
                                    title="Submission Id"/>
                </v-flex>
                <v-flex xs2>
                  <v-list class="pa-0" two-line>
                    <v-list-item class="pa-0">
                      <v-list-item-content class="py-0">
                        <v-list-item-subtitle style="font-size: 12px;user-select: text;">Document No.
                        </v-list-item-subtitle>
                        <v-list-item-title style="font-size: 17px; user-select: text;">
                          {{ visa.passport_document.document_number }}
                        </v-list-item-title>
                        <span
                            style="font-size: 12px; user-select: text;">({{
                            visa.passport_document.document_type
                          }})</span>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-flex>
                <v-flex xs2>
                  <list-item-detail
                      sub_title="Applied"
                      title="Status"/>
                </v-flex>
                <v-flex xs2>
                  <list-item-detail
                      :sub_title="visa.created_at"
                      title="Applied at"/>
                </v-flex>
                <v-flex xs2>
                  <list-item-detail
                      :sub_title="visa.office"
                      title="Office"/>
                </v-flex>
                <v-flex class="pt-4" xs1>
                  <v-btn @click="viewVisa(visa.submission_no)" color="primary" fab x-small>
                    <v-icon>
                      remove_red_eye
                    </v-icon>
                  </v-btn>
                </v-flex>
                <v-flex v-if="index < traveller.visa_requests.length-1" xs12>
                  <v-divider/>
                </v-flex>
              </v-layout>
            </div>
            <div v-if="traveller.not_approved_visa_requests && traveller.not_approved_visa_requests.length > 0">
              <v-layout class="ml-3 py-1" row v-for="(visa,index) in traveller.not_approved_visa_requests" :key="index" wrap>
                <v-flex xs2>

                  <v-list class="pa-0" two-line>
                    <v-list-item class="pa-0">
                      <v-list-item-content class="py-0">
                        <v-list-item-subtitle style="font-size: 12px;user-select: text;">Visa Type
                        </v-list-item-subtitle>
                        <v-list-item-title style="font-size: 17px; user-select: text;">{{ visa.visa_type }}
                        </v-list-item-title>
                        <span
                            style="font-size: 12px; user-select: text;">({{
                            visa.visa_condition ? visa.visa_condition.name : 'n/a'
                          }})</span>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-flex>


                <v-flex xs1>
                  <list-item-detail :sub_title="visa.submission_no"
                                    title="Submission Id"/>
                </v-flex>
                <v-flex xs2>
                  <v-list class="pa-0" two-line>
                    <v-list-item class="pa-0">
                      <v-list-item-content class="py-0">
                        <v-list-item-subtitle style="font-size: 12px;user-select: text;">Document No.
                        </v-list-item-subtitle>
                        <v-list-item-title style="font-size: 17px; user-select: text;">
                          {{ visa && visa.document ? visa.document.document_number : 'N/A' }}
                        </v-list-item-title>
                        <span
                            style="font-size: 12px; user-select: text;">({{
                            visa && visa.document ? visa.document.document_type.name : 'N/A'
                          }})</span>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-flex>
                <v-flex xs2>
                  <list-item-detail
                      :sub_title="visa.status"
                      title="Status"/>
                </v-flex>
                <v-flex xs2>
                  <list-item-detail
                      :sub_title="visa.created_at"
                      title="Created at"/>
                </v-flex>
                <v-flex xs2>
                  <list-item-detail
                      :sub_title="visa.office"
                      title="Office"/>
                </v-flex>
                <v-flex class="pt-4" xs1>
                  <v-btn @click="viewVisa(visa.submission_no)" color="primary" fab x-small>
                    <v-icon>
                      remove_red_eye
                    </v-icon>
                  </v-btn>
                  <!--                                <v-tooltip top>-->
                  <!--                                    <template v-slot:activator="{ on }">-->
                  <!--                                        <v-btn-->
                  <!--                                                @click="editVisa(visa)"-->
                  <!--                                                class="ml-1"-->
                  <!--                                                color="#FF8316"-->
                  <!--                                                dark-->
                  <!--                                                dense-->
                  <!--                                                fab-->
                  <!--                                                v-if="$oauth.checkIfHasPermission(['update visa-record']) && (index === 0 || visa.submission_no.substr(0,1).toLowerCase() === 'p')"-->
                  <!--                                                v-on="on"-->
                  <!--                                                x-small-->
                  <!--                                        >-->
                  <!--                                            <v-icon small>edit</v-icon>-->
                  <!--                                        </v-btn>-->
                  <!--                                    </template>-->
                  <!--                                    <span>Edit Expiry Date</span>-->
                  <!--                                </v-tooltip>-->
                </v-flex>
                <v-flex
                    v-if="traveller.not_approved_visa_requests && (index < traveller.not_approved_visa_requests.length-1)"
                    xs12>
                  <v-divider/>
                </v-flex>
              </v-layout>
            </div>
          </v-tab-item>

          <v-tab-item value="similar_travellers">
            <div>
              <similar-travellers :similar_travellers="traveller.similar_travellers"/>
            </div>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-container>

    <v-dialog
        persistent
        transition="dialog-bottom-transition"
        v-if="$oauth.checkIfHasPermission(['alter traveller-details'])"
        v-model="travellerDialog"
        width="700">
      <v-card>
        <v-toolbar color="blue darken-3" dark>
          <v-toolbar-title>Edit Traveller</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-0">
          <v-container class="pb-0" grid-list-md>
            <v-layout wrap>
              <form-error-display-handler :errors="errors" v-if="errors"/>
              <v-flex xs12>
                <v-form class="pa-2" lazy-validation ref="formRef">
                  <v-flex class="px-0" xs12>
                    <v-text-field
                        :rules="[rules.required]"
                        id="fullName"
                        label="Full Name *"
                        outlined
                        type="text"
                        v-model="traveller.full_name"
                    />
                  </v-flex>
                  <v-layout class="pa-0" wrap>
                    <v-flex xs6>
                      <v-select
                          :items="genders"
                          :rules="[rules.required]"
                          id="gender"
                          label="Gender *"
                          outlined
                          v-model="traveller.gender"
                      />
                    </v-flex>

                    <v-flex xs6>
                      <new-date-picker
                          :key="form.dob"
                          :maxYear="getCurrentYear()"
                          :minYear="getYearPreviousOrAfterCurrent(-90)"
                          label="Date of Birth *"
                          v-model="traveller.dob"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs6>
                      <v-combobox
                          :items="occupationList"
                          :rules="[rules.required]"
                          id="occupation"
                          label="Occupation *"
                          outlined
                          v-model="traveller.occupation"
                      />
                    </v-flex>
                    <v-flex xs6 v-if="traveller && traveller.country && traveller.country.country_name == 'Other'">
                      <v-autocomplete
                          :clearable="true"
                          :items="countries"
                          :rules="[rules.required]"
                          item-text="country_name"
                          item-value="id"
                          label="Select Country *"
                          outlined
                          v-model="traveller.country.id"
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex xs6>
                      <v-text-field
                          :label=contactLabel
                          :rules="[rules.required]"
                          id="contactNumber"
                          min="0"
                          outlined
                          type="number"
                          v-model="traveller.contact_number"
                      />
                    </v-flex>
                  <v-flex class="px-0" xs6>
                    <v-text-field
                        :rules="[rules.email]"
                        id="email"
                        label="Email"
                        outlined
                        type="email"
                        v-model="traveller.email"
                    />
                  </v-flex>
                  <v-flex
                      class="px-0"
                      xs12
                  >

                    <!--                                        <file-input-->
                    <!--                                                placeholder="JPEG, JPG or PNG only"-->
                    <!--                                                :valid_file_types="['png', 'jpeg', 'jpg']"-->
                    <!--                                                label="Passport Size Image"-->
                    <!--                                                v-model="display_image"-->
                    <!--                                                :image-url="traveller.image"-->
                    <!--                                                id="userImage"-->
                    <!--                                                :fileSize="2048"-->
                    <!--                                        />-->
                  </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn
              @click="travellerDialog=false"
              class="white--text"
              color="red lighten-1"
          >Cancel
          </v-btn>
          <v-btn
              :loading="loading"
              @click="updateTraveller"
              class="white--text"
              color="blue darken-3"
          >Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
        persistent
        transition="dialog-bottom-transition"
        v-if="$oauth.checkIfHasPermission(['alter visa-request'])"
        v-model="form"
        width="650">
      <v-card>
        <v-toolbar color="blue darken-3" dark>
          <v-toolbar-title>Edit Visa Information</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-0">
          <v-container grid-list-md>
            <v-layout row>
              <v-flex xs12>
                <v-form class="pa-2" lazy-validation ref="formRef">
                  <v-layout class="mb-8 mx-0" row>
                    <form-error-display-handler :errors="errors"></form-error-display-handler>
                    <v-flex xs8>
                      <v-text-field v-if="visa.sticker_number !== null && visa.sticker_number !== 'null'"
                                    :rules="[rules.required,rules.number,rules.maxStickerNumberLen]"
                                    label="Visa Sticker Number *"
                                    outlined
                                    v-model="visa.sticker_number"
                                    @keydown="notAllowToInput($event,visa.sticker_number.toString().length)"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-checkbox v-model="canChangeVisaType" label="Edit Visa Condition"/>
                    </v-flex>
                    <v-flex md6 xs12 v-if="canChangeVisaType">
                      <v-select
                          :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                          :items="visaTypes"
                          :rules="[rules.required]"
                          id="visaType"
                          item-text="type"
                          item-value="id"
                          label="Visa Type *"
                          outlined
                          v-model="visa.visa_types"
                          @change="checkVisaCondition"
                      ></v-select>
                    </v-flex>
                    <v-flex md6 xs12 v-if="canChangeVisaType">
                      <v-select
                          :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                          :items="visaConditions"
                          :rules="[rules.required]"
                          id="visaCondition"
                          item-text="visa_condition"
                          item-value="id"
                          label="Visa Condition *"
                          outlined
                          v-model="visa.visa_condition"
                      ></v-select>
                    </v-flex>
                    <v-flex md6 xs12 v-if="isDependent">
                      <v-text-field
                          :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                          id="dependent_passport_no"
                          label="Host Passport Number *"
                          outlined
                          v-model="visa.dependent_passport_no"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md6 xs12 v-if="isDependent">
                      <v-text-field
                          :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                          id="dependent_visa_no"
                          label="Host Latest Visa Number *"
                          outlined
                          v-model="visa.dependent_visa_no"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs6>
                      <new-date-picker
                          :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                          :maxYear=getYearPreviousOrAfterCurrent(1)
                          label="Visa Start Date *"
                          v-model="visa.start_date"
                      />
<!--                          :maxYear=getCurrentYear()-->
                    </v-flex>
                    <v-flex class="pl-2" xs6>
                      <new-date-picker
                          :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                          :maxYear=getYearPreviousOrAfterCurrent(15)
                          label="Visa Expiry Date *"
                          v-model="visa.expiry_date"
                      />
                    </v-flex>
                    <v-flex class="mt-4" xs12 v-if="visa.approved_date === null">
                      <new-date-picker
                          :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                          :maxYear=getYearPreviousOrAfterCurrent(3)
                          label="Visa Approved Date *"
                          v-model="approved_date"
                      />
                    </v-flex>
                    <v-flex class="mt-4" xs12>
                      <multiple-file-upload
                          label="Attachments (if any)"
                          v-model="visa.attachments"/>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                          :rules="[rules.required]"
                          label="Valid Reason *"
                          outlined
                          type="text"
                          v-model="visa.reason"
                      ></v-textarea>
                    </v-flex>
                  </v-layout>

                  <!--                                    <file-input-->
                  <!--                                            :required="true"-->
                  <!--                                            label="Valid Image *"-->
                  <!--                                            v-model="visa.visa"-->
                  <!--                                            :file-size="1024"></file-input>-->
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              @click="cancelUpdateVisa"
              class="white--text"
              color="red lighten-1"
          >Cancel
          </v-btn>
          <v-btn
              :loading="loading"
              @click="updateVisa"
              class="white--text"
              color="blue darken-3"
          >Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        persistent
        transition="dialog-bottom-transition"
        v-model="document_form"
        width="650">
      <v-card>
        <v-toolbar color="blue darken-3" dark>
          <v-toolbar-title>Edit Document Type</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-0">
          <v-container grid-list-md>
            <v-layout row>
              <v-flex xs12>
                <v-form class="pa-2" lazy-validation ref="formRef">
                  <v-layout class="mb-8 mx-0" row>
                    <v-flex md6 pr-2 xs12>
                      <v-select
                          :items="passportTypes"
                          :rules="[rules.required]"
                          label="Document Type *"
                          outlined
                          v-model="document.document_type"
                      />
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              @click="document_form=false"
              class="white--text"
              color="red lighten-1"
          >Cancel
          </v-btn>
          <v-btn
              :loading="loading"
              @click="updateDocument"
              class="white--text"
              color="blue darken-3"
          >Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        persistent
        transition="dialog-bottom-transition"
        v-model="separateTravellerForm"
        width="650">
      <v-card>
        <v-toolbar color="blue darken-3" dark>
          <v-toolbar-title>Mark this document ( {{ document.document_number }} ) as separate traveller</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-0">
          <v-container grid-list-md>
            <v-layout row>
              <v-flex xs12>
                <v-form class="pa-2" lazy-validation ref="formRef">
                  <v-layout class="mb-8 mx-0" row>
                    <v-flex md12 pr-2 xs12>
                      <v-text-field
                          :rules="[rules.required]"
                          label="Reason *"
                          outlined
                          v-model="document.reason"
                      />
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              @click="separateTravellerForm=false"
              class="white--text"
              color="red lighten-1"
          >Cancel
          </v-btn>
          <v-btn
              :loading="loading"
              @click="separateTravellerDocument"
              class="white--text"
              color="blue darken-3"
          >Mark
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <special-payment-dialog :traveller-id="traveller.id" @vouchergenerated="spcVoucherGenerated"/>

    <entry-refuse-dialog :traveller-id="traveller.id" :country-name="traveller.country.country_name"
                         @entryRefused="unmarked"/>

    <attach-file-dialog
        :url="'traveller/attach-file/' + traveller.id"
        @attached="callChangedData"
        v-model="attachFileDialog"
    />

    <s-c-p-voucher-print-content v-if="showSCPVoucherContent" style="display: none"/>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import {validationMixin} from "../../mixins/validationMixin";
import {commonListMixin} from "../../mixins/commonListMixin";
import ListItemDetail from "../../components/ListItemDetail";
import FileListItemDetail from "../../components/FileListItemDetail";
import ConfirmationHeaderText from "../../components/ConfirmationHeaderText";
import FileDisplay from "../../components/FileDisplay";
import FormErrorDisplayHandler from "../../components/FormErrorDisplayHandler";
import FileInput from "../../components/FileInput";
import VisaHistory from "../visa/visa-request/VisaHistory";
import YearLog from "./YearLog";
import SimilarTravellers from "@/views/traveller/SimilarTravellers";
import FingerPrint from "./FingerPrint";
import RetinaScan from "./RetinaScan";
import Http from "axios";
import {API_URL, VERSION, VERSIONED_API_URL} from "../../config/config";
import NewDatePicker from "../../components/NewDatePicker";
import ExportExcelButton from "../../components/ExportExcelButton";

import {passportTypes} from "../../constants/AppConstant";
import MultipleFileUpload from "../../components/MultipleFileUpload";
import BlackListDetail from "../../components/visa/BlackListDetail";
import SpecialPaymentDialog from "../../components/dialogs/SpecialCasePaymentDialog";
import EntryRefuseDialog from "../../components/dialogs/EntryRefuseDialog";
import SCPVoucherPrintContent from "../../components/dialogs/SCPVoucherPrintContent";
import {SET_PRINT_CONTENT} from "../../store/mutation-type";
import EntryRefuse from "../../components/visa/history/EntryRefuse";
import AttachFileDialog from "../../components/dialogs/AttachFileDialog";
import TravellerScanHistory from "@/components/TravellerScanHistory";
import TravellerPreviousStayLog from "./TravellerPreviousStayLog.vue";
export default {
  components: {
    TravellerPreviousStayLog,
    AttachFileDialog,
    EntryRefuse,
    BlackListDetail,
    MultipleFileUpload,
    NewDatePicker,
    RetinaScan,
    FingerPrint,
    YearLog,
    ListItemDetail,
    FileDisplay,
    ConfirmationHeaderText,
    FileListItemDetail,
    VisaHistory,
    FormErrorDisplayHandler,
    FileInput,
    ExportExcelButton,
    SpecialPaymentDialog,
    EntryRefuseDialog,
    SCPVoucherPrintContent,
    SimilarTravellers,
    TravellerScanHistory
  },
  mixins: [validationMixin, commonListMixin],
  data() {
    return {
      imageShow: false,
      imageSingle: null,
      detailDialog: false,
      documentVisaVisits: [],
      profile: require("../../assets/logo.png"),
      documentVisasLoading: false,
      reportLoading: false,
      detailTab: 'profile',
      travellerDialog: false,
      genders: ['Male', 'Female', 'Others'],
      occupationList: [],
      errors: [],
      display_image: null,
      visa: {},
      form: false,
      canChangeVisaType: false,
      document_form: false,
      document: {},
      passportTypes,
      isDependent: false,
      visaConditions: [],
      showSCPVoucherContent: false,
      approved_date: null,
      attachFileDialog: false,
      separateTravellerForm: false
    };
  },
  props: {
    id: String
  },
  computed: {
    ...mapGetters("TravellerSingle", ["traveller", "loading", "profile_images"]),
    ...mapGetters({
      countries: "CountryList/all",
      currentUser: "AuthUser/user",
    }),
    showVisaDetails() {
      let show_visa = true;
      if (this.traveller && this.traveller.country) {
        let country = this.traveller.country.country_name;
        if (country.toLowerCase() === 'nepal' || country.toLowerCase() === 'india')
          show_visa = false;
      }
      return show_visa;
    },
    history() {
      return this.$store.state.TravellerSingle.histories;
    },
    scan_histories() {
      return this.$store.state.TravellerSingle.scan_histories;
    },
    // visaTypes() {
    //     return this.$store.state.NewVisaEntry.visaTypes;
    //     // .filter((item) => item.visa_type_name.toLowerCase() !== "dependent visa");
    // },
    visaTypes() {
      return this.$store.state.VisaTypeList.all.filter(i => i.slug !== 'dependent-visa');
    },
    contactLabel() {
      let country_name = this.traveller.country && this.traveller.country.country_name ? this.traveller.country.country_name : this.traveller.country;
      return `Contact Number of ${country_name} *`;
    }
  },
  methods: {
    ...mapActions("TravellerSingle", ["resetState", "getTravellerDetail", "getHistory", "getTravellerProfileImages","getScanHistory"]),
    ...mapActions({
      fetchCountries: "CountryList/fetchAllCountries",
    }),
    // ...mapActions("NewVisaEntry", ["getVisaTypeConditionAll"]),
    actionClick() {
      console.log(1);
    },
    attachDocument() {
      this.attachFileDialog = true;
    },
    openLink(url) {
      window.open(url, "_blank");
    },
    viewVisa(submission_no) {
      window.open('/admin/system/visa-requests/view/' + submission_no, '_blank')
    },
    editTraveller() {
      this.fetchOccupations();
      this.travellerDialog = true;
    },
    fetchOccupations() {
      try {
        Http.get(`${API_URL}${VERSION}` + '/dynamic-values-setup/fetch-all', {
          params: {
            key: 'occupations',
          }
        }).then((response) => {
          let items = response.data.map((item) => item.value);
          items = items.map(i => i.name);
          items.push('Others');
          this.occupationList = items;
        })
      } catch (e) {
        throw e;
      }
    },
    updateTraveller() {
      if (this.$refs.formRef.validate()) {
        let formData = new FormData();
        formData.set("full_name", this.traveller.full_name);
        formData.set("dob", this.traveller.dob);
        formData.set("gender", this.traveller.gender);
        formData.set("occupation", this.traveller.occupation);
        formData.set("contact_number", this.traveller.contact_number);
        formData.set("email", this.traveller.email);
        if (this.traveller.country && this.traveller.country.id){
          formData.set('country_id',this.traveller.country.id)
        }
        // if (this.display_image)
        //     formData.set("image", this.display_image);
        Http.post(`${API_URL}${VERSION}/traveller/${this.traveller.id}`, formData
        )
            .then(() => {
              this.$store.commit('Notification/showSuccess', 'Traveller Detail Updated Successfully');
              this.travellerDialog = false;
              this.getTravellerDetail(this.$route.params.id);
            })
            .catch((er) => {
                  this.errors = er.response.data.errors;
                  this.$store.commit('Notification/showError', 'Something went wrong');
                }
            );
      }
    }
    ,
    // viewVisa(item) {
    //     this.$router.push({
    //         name: "ViewVisaRequest",
    //         params: {id: item.id.toString()}
    //     });
    // }

    editVisa(item) {
      this.visa = item;
      this.form = true;
      const sub_str = this.visa.submission_no.substr(0, 1);
      // if (sub_str === 'O' || sub_str === "P"){
      //     this.canChangeVisaType = true
      // }else{
      //     this.canChangeVisaType = false
      // }
    },

    updateVisa() {
      if (this.$refs.formRef.validate()) {
        this.loading = true;
        let formData = new FormData();
        formData.set('visa_sticker_number', this.visa.sticker_number);
        formData.set('start_date', this.visa.start_date);
        formData.set('expiry_date', this.visa.expiry_date);
        formData.set('reason', this.visa.reason);
        if (this.approved_date)
          formData.set('approved_date', this.approved_date);

        let files = this.visa.attachments;
        if (files !== undefined) {
          for (let i = 0; i < files.length; i++) {
            formData.append(`files[${i}]`, files[i]);
          }
        }

        if (this.canChangeVisaType === true)
          formData.set('visa_condition', this.visa.visa_condition)
        if (this.visa.visa)
          formData.set('visa', this.visa.visa);

        if (this.isDependent && this.visa.dependent_passport_no && this.visa.dependent_visa_no) {
          formData.set("dependent_visa", true);
          formData.set("dependent_passport_no", this.visa.dependent_passport_no);
          formData.set("dependent_visa_no", this.visa.dependent_visa_no);
        }

        Http.post(`${API_URL}${VERSION}/visa/${this.visa.id}/update`, formData).then(() => {
          this.loading = false;
          this.cancelUpdateVisa();
          this.$store.commit("Notification/showSuccess", "Visa Info changed successfully");
          this.getTravellerDetail(this.$route.params.id);
        })
            .catch((e) => {
              this.loading = false;
              this.errors = e.response.data;
              this.$store.commit("Notification/showError", e.response.data.message);
            })
      }
    },

    cancelUpdateVisa() {
      this.form = false;
      this.canChangeVisaType = false
      this.errors = [];
    },

    editDocument(item) {
      this.document = item;
      this.document_form = true;
    },
    separateTraveller(item) {
      this.document = item;
      this.separateTravellerForm = true;
    },
    updateDocument() {
      if (this.$refs.formRef.validate()) {
        this.loading = true;
        Http.post(`${API_URL}${VERSION}/documents/${this.document.id}/update`, {
          "document_type": this.document.document_type
        }).then(() => {
          this.loading = false;
          this.document_form = false;
          this.$store.commit("Notification/showSuccess", "Document Type changed successfully")
        })
            .catch((e) => {
              this.loading = false;
              this.$store.commit("Notification/showError", e.response.data.message);
            })
      }
    },
    separateTravellerDocument() {
      if (this.$refs.formRef.validate()) {
        this.loading = true;
        Http.post(`${API_URL}${VERSION}/documents/${this.document.document_number}/separate`, {
          "reason": this.document.reason
        }).then(() => {
          this.loading = false;
          this.separateTravellerForm = false;
          this.$store.commit("Notification/showSuccess", "Document separated  successfully")
          this.getTravellerDetail(this.$route.params.id);
          this.getHistory(this.$route.params.id);
          this.getTravellerProfileImages(this.$route.params.id);
        })
            .catch((e) => {
              this.loading = false;
              this.$store.commit("Notification/showError", e.response.data.message);
            })
      }
    },
    checkVisaCondition() {
      this.isDependent = this.visaTypes.find((i) => i.id === this.visa.visa_types).slug.includes('dependent');
      Http.get(`${VERSIONED_API_URL}/visa-types-conditions/visa-type/${this.visa.visa_types}`)
          .then((res) => {
            this.visaConditions = res.data.data;
          })
          .catch(() => {
            this.$store.commit("Notification/showError", "Something went wrong");
          })
    },
    downloadAsPdf() {
      Http.get(`${VERSIONED_API_URL}/${this.$route.params.id}/generate-report`)
          .then((res) => {
            window.open(res.data.link, "_blank");
          })
          .catch(() => {
            this.$store.commit("Notification/showError", "Something went wrong");
          })
    },
    notAllowToInput(e, length) {
      if ((length === 7) && e.keyCode !== 46 // keycode for delete
          && e.keyCode !== 8) {
        e.preventDefault();
      }
    },
    unmarked() {
      this.getTravellerDetail(this.$route.params.id);
      this.getHistory(this.$route.params.id);
    },
    showSpecialPaymentDialog() {
      this.$store.commit("TravellerSingle/setSpecialCasePaymentDialog", true);
    },
    showEntryRefuseDialog() {
      this.$store.commit("TravellerSingle/setEntryRefuseDialog", true);
    },
    spcVoucherGenerated() {
      this.showSCPVoucherContent = true;
      this.getHistory(this.$route.params.id).then(() => {
        const content = document.getElementById('scp_voucher_print_content').innerHTML;
        this.$store.commit(SET_PRINT_CONTENT, content);
      });
    },
    callChangedData() {
      this.getHistory(this.$route.params.id);
    }
  },
  watch: {
    "$route.params.id": function (id) {
      this.getTravellerDetail(id);
    }
  },
  mounted() {
    this.getTravellerDetail(this.$route.params.id);
    this.getHistory(this.$route.params.id);
    this.getScanHistory(this.$route.params.id);
    this.getTravellerProfileImages(this.$route.params.id);
    this.fetchCountries();
    // this.getVisaTypeConditionAll();
    this.$store.dispatch("VisaTypeList/fetchAll");
    this.passportTypes.push("Voter Card");
    this.passportTypes.push("Aadhar Card");
    this.passportTypes.push("Citizenship");

  }
};
</script>
<style type="text/css">
.fingerprint {
  font-size: 12px;
  user-select: text;
  color: #7D7D7D;
  margin-bottom: 8px !important;
}
</style>

